{
  "page": {
    "eyebrow": "審核管理",
    "title": "管理後台",
    "subtitle": "審核拍賣品、訂單、爭議、用戶及平台狀態。",
    "loading": "載入中…"
  },
  "tabs": {
    "overview": "總覽",
    "users": "用戶",
    "sellers": "賣家",
    "sellersReview": "賣家審核",
    "auctions": "拍賣",
    "orders": "訂單",
    "payments": "付款",
    "payouts": "撥款",
    "shipments": "寄件",
    "disputes": "爭議",
    "reports": "舉報",
    "settings": "設定",
    "reviews": "評價",
    "financial": "財務",
    "health": "系統狀態",
    "webhooks": "Webhooks",
    "audit": "操作紀錄",
    "promotions": "精選推廣",
    "aiAnalytics": "AI 分析",
    "marketData": "市場數據",
    "cron": "排程狀態",
    "push": "推播狀態",
    "cardMaster": "卡牌資料庫",
    "emailCentre": "電郵中心",
    "advertising": "廣告與合作夥伴",
    "homepageStats": "首頁統計",
    "newsletter": "電子報",
    "community": "社群",
    "events": "活動",
    "articles": "文章",
    "dealers": "商戶名錄",
    "sellerTrust": "賣家信譽",
    "launch": "上線檢查表",
    "stripe": "Stripe 除錯"
  },
  "overview": {
    "title": "平台總覽",
    "subtitle": "BidNova Auctions 平台活動概覽。",
    "loading": "正在載入總覽…",
    "error": "無法載入總覽。",
    "totalUsers": "用戶總數",
    "activeSellers": "活躍賣家",
    "approvedSellers": "已核准賣家",
    "liveAuctions": "進行中拍賣",
    "orders": "訂單",
    "ordersLive": "{count} 張進行中",
    "grossSales": "總成交金額",
    "pendingPayouts": "待撥款",
    "shipments": "寄件數目",
    "activeDisputes": "進行中爭議"
  }
}
